import React from 'react';
import { useParams } from 'react-router-dom';

import { ContentSettings } from '@candu-ai/content/settings';
import { useNavigation } from 'commons/hooks';
import { CONTENT_PATH, contentPath } from 'dashboard/pages/Content/constants';

export const GeneralPage = () => {
  const navigate = useNavigation();
  const { id: contentId } = useParams();
  const onContentArchived = () => {
    navigate(CONTENT_PATH);
  };

  const onContentCloned = (id: string) => {
    navigate(contentPath(id));
  };
  return (
    <ContentSettings
      contentId={contentId}
      onContentCloned={onContentCloned}
      onContentArchived={onContentArchived}
    />
  );
};

export default GeneralPage;
